(function () {
  'use strict';

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;

  /* ---------------- storage with graceful failure ---------------- */
  var memoryStore = {};
  function storeGet(key) {
    try { var v = window.localStorage.getItem(key); return v === null ? (key in memoryStore ? memoryStore[key] : null) : v; }
    catch (e) { return (key in memoryStore) ? memoryStore[key] : null; }
  }
  function storeSet(key, value) {
    memoryStore[key] = value;
    try { window.localStorage.setItem(key, value); } catch (e) { /* private mode / blocked - memory only */ }
  }

  function inDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function urlFlag(name) {
    try { return new URLSearchParams(window.location.search).get(name); }
    catch (e) { return null; }
  }

  function prefersReducedMotion() {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    catch (e) { return false; }
  }

  /* ============================ INSTANCE ============================ */
  function init(root) {
    if (!root || root.__cbwInitialised) return;
    root.__cbwInitialised = true;

    var cfgEl = root.querySelector('[data-cbw-config]');
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); }
    catch (e) { return; }

    /* Move the root to <body> so no ancestor transform/overflow can trap
       the fixed-position overlay or teaser. */
    if (root.parentNode !== document.body) document.body.appendChild(root);
    root.hidden = false;

    var overlay   = root.querySelector('[data-cbw-overlay]');
    var dialog    = root.querySelector('[data-cbw-dialog]');
    var teaser    = root.querySelector('[data-cbw-teaser]');
    var form      = root.querySelector('[data-cbw-form]');
    var emailInp  = root.querySelector('[data-cbw-email]');
    var submitBtn = root.querySelector('[data-cbw-submit]');
    var msgEl     = root.querySelector('[data-cbw-msg]');
    var liveEl    = root.querySelector('[data-cbw-live]');
    var closeBtn  = root.querySelector('[data-cbw-close]');
    var dismissEl = root.querySelector('[data-cbw-dismiss]');
    var copyBtn   = root.querySelector('[data-cbw-copy]');
    var copyLabel = root.querySelector('[data-cbw-copy-label]');
    var confettiEl= root.querySelector('[data-cbw-confetti]');
    var badge     = root.querySelector('[data-cbw-preview-badge]');
    var secondary = root.querySelectorAll('[data-cbw-close-secondary]');

    var ns          = (cfg.storageNamespace || 'caribbrew') + ':';
    var KEY_SUBBED  = ns + 'subscribed';
    var KEY_DISMISS = ns + 'dismissedUntil';

    var state = 'form';
    var isOpen = false;
    var inFlight = false;
    var lastSubmittedEmail = '';
    var lastFocused = null;
    var timers = [];
    var scrollY = 0;
    var destroyed = false;

    /* Preview: only ever active inside the theme editor, or via ?cbw_preview= */
    var previewParam = urlFlag('cbw_preview');
    var previewMode = 'off';
    if (inDesignMode() && cfg.previewMode && cfg.previewMode !== 'off') previewMode = cfg.previewMode;
    if (previewParam && ['form', 'pending', 'success'].indexOf(previewParam) > -1) previewMode = previewParam;
    var isPreview = previewMode !== 'off';
    if (isPreview && badge) badge.hidden = false;

    function later(fn, ms) { var t = window.setTimeout(fn, ms); timers.push(t); return t; }
    function clearTimers() { timers.forEach(window.clearTimeout); timers = []; }

    function hasSubscribed() { return storeGet(KEY_SUBBED) === '1'; }
    function isSuppressed() {
      var until = parseInt(storeGet(KEY_DISMISS) || '0', 10);
      return !isNaN(until) && until > Date.now();
    }
    function suppress(days) {
      var d = parseInt(days, 10);
      if (isNaN(d) || d <= 0) return;
      storeSet(KEY_DISMISS, String(Date.now() + d * 86400000));
    }

    /* ------------------------- state machine ------------------------- */
    function replayReveal(viewName) {
      var view = root.querySelector('.cbw-view--' + viewName);
      if (!view || prefersReducedMotion()) return;
      var kids = view.children, i;
      for (i = 0; i < kids.length; i++) {
        kids[i].style.transition = 'none';
        kids[i].style.opacity = '0';
        kids[i].style.transform = 'translate3d(0,12px,0)';
      }
      void view.offsetWidth; /* force reflow so the reset is committed */
      for (i = 0; i < kids.length; i++) {
        kids[i].style.transition = '';
        kids[i].style.transitionDelay = (120 + i * 62) + 'ms';
        kids[i].style.opacity = '';
        kids[i].style.transform = '';
      }
    }

    function setState(next) {
      state = next;
      root.setAttribute('data-state', next);
      if (next === 'success' || next === 'pending') {
        var h = root.querySelector('.cbw-view--' + next + ' .cbw-heading');
        if (h) {
          if (!h.id) h.id = 'cbw-heading-' + (cfg.storageNamespace || 'cbw') + '-' + next + '-' + root.getAttribute('data-section-id');
          dialog.setAttribute('aria-labelledby', h.id);
        }
        if (isOpen) replayReveal(next);
        var focusTarget = root.querySelector('.cbw-view--' + next + ' .cbw-btn, .cbw-view--' + next + ' .cbw-copy');
        if (isOpen && focusTarget) later(function () { try { focusTarget.focus({ preventScroll: true }); } catch (e) {} }, 320);
      }
    }

    function announce(text) { if (liveEl) liveEl.textContent = text || ''; }

    function showMessage(text, tone) {
      if (!msgEl) return;
      msgEl.textContent = text || '';
      msgEl.setAttribute('data-tone', tone || 'info');
    }

    /* --------------------------- teaser --------------------------- */
    function showTeaser() {
      if (!teaser) return;
      if (!cfg.teaserEnabled) return;
      if (hasSubscribed()) return;
      if (isOpen) return;
      teaser.classList.add('is-visible');
    }
    function hideTeaser() { if (teaser) teaser.classList.remove('is-visible'); }

    /* --------------------------- focus trap --------------------------- */
    var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
    function focusables() {
      return Array.prototype.filter.call(dialog.querySelectorAll(FOCUSABLE), function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      });
    }
    function onKeydown(e) {
      if (!isOpen) return;
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close('escape'); return; }
      if (e.key !== 'Tab') return;
      var list = focusables();
      if (!list.length) { e.preventDefault(); dialog.focus(); return; }
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    /* --------------------------- scroll lock --------------------------- */
    function lockScroll() {
      scrollY = window.scrollY || window.pageYOffset || 0;
      var sbw = window.innerWidth - document.documentElement.clientWidth;
      if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
      document.body.classList.add('cbw-scroll-locked');
    }
    function unlockScroll() {
      document.body.classList.remove('cbw-scroll-locked');
      document.body.style.paddingRight = '';
    }

    /* ------------------------- open / close ------------------------- */
    function open(source) {
      if (isOpen || destroyed) return;
      isOpen = true;
      lastFocused = document.activeElement;
      hideTeaser();
      lockScroll();
      root.classList.remove('is-closing');
      root.classList.add('is-open');
      overlay.removeAttribute('aria-hidden');
      document.addEventListener('keydown', onKeydown, true);
      later(function () {
        var target = (state === 'form') ? emailInp : dialog;
        if (target && typeof target.focus === 'function') target.focus({ preventScroll: true });
      }, 260);
      root.dispatchEvent(new CustomEvent('cbw:open', { bubbles: true, detail: { source: source || 'manual' } }));
    }

    function close(reason) {
      if (!isOpen || destroyed) return;
      isOpen = false;
      root.classList.remove('is-open');
      root.classList.add('is-closing');
      overlay.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', onKeydown, true);
      unlockScroll();

      if (reason === 'dismiss' || reason === 'escape' || reason === 'backdrop' || reason === 'close') {
        if (!hasSubscribed()) suppress(cfg.frequencyDays);
      }

      later(function () { root.classList.remove('is-closing'); }, 420);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        try { lastFocused.focus({ preventScroll: true }); } catch (e) {}
      }
      if (!hasSubscribed()) later(showTeaser, 260);
      root.dispatchEvent(new CustomEvent('cbw:close', { bubbles: true, detail: { reason: reason || 'manual' } }));
    }

    /* --------------------------- confetti --------------------------- */
    function burstConfetti() {
      if (!cfg.confetti || !confettiEl || prefersReducedMotion()) return;
      confettiEl.innerHTML = '';
      var colors = cfg.confettiColors || ['#E2762A'];
      var frag = document.createDocumentFragment();
      var count = 34;
      for (var i = 0; i < count; i++) {
        var p = document.createElement('i');
        p.style.left = (Math.random() * 100) + '%';
        p.style.background = colors[i % colors.length];
        p.style.setProperty('--cbw-x', (Math.random() * 160 - 80).toFixed(0) + 'px');
        p.style.setProperty('--cbw-y', (220 + Math.random() * 260).toFixed(0) + 'px');
        p.style.setProperty('--cbw-rot', (Math.random() * 720 - 360).toFixed(0) + 'deg');
        p.style.setProperty('--cbw-dur', (1500 + Math.random() * 1100).toFixed(0) + 'ms');
        p.style.setProperty('--cbw-delay', (Math.random() * 320).toFixed(0) + 'ms');
        if (i % 3 === 0) { p.style.width = '6px'; p.style.height = '6px'; p.style.borderRadius = '50%'; }
        frag.appendChild(p);
      }
      confettiEl.appendChild(frag);
      later(function () { if (confettiEl) confettiEl.innerHTML = ''; }, 2900);
    }

    /* -------------------- Klaviyo client subscription --------------------
       POST https://a.klaviyo.com/client/subscriptions/?company_id=<PUBLIC SITE ID>
       Public site ID only. A 202 means "accepted", not "confirmed".
    ---------------------------------------------------------------------- */
    function subscribe(email) {
      var url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.siteId);
      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: cfg.customSource || 'Caribbrew Signup Popup',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: {
                    signup_source: cfg.customSource || 'Caribbrew Signup Popup',
                    signup_page: window.location.pathname
                  },
                  subscriptions: {
                    email: { marketing: { consent: 'SUBSCRIBED' } }
                  }
                }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: cfg.listId } }
          }
        }
      };

      var controller = (typeof AbortController !== 'undefined') ? new AbortController() : null;
      var timeout = later(function () { if (controller) controller.abort(); }, 15000);

      return fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': cfg.revision || '2026-07-15'
        },
        body: JSON.stringify(payload),
        signal: controller ? controller.signal : undefined,
        keepalive: true
      }).then(function (res) {
        window.clearTimeout(timeout);
        return res;
      }).catch(function (err) {
        window.clearTimeout(timeout);
        throw err;
      });
    }

    function onAccepted(email) {
      lastSubmittedEmail = '';
      if (cfg.optinMode === 'double') {
        setState('pending');
        announce(cfg.text.pendingStatus);
        /* Not marked as subscribed: opt-in is not confirmed yet. */
      } else {
        storeSet(KEY_SUBBED, '1');
        setState('success');
        announce(cfg.text.successStatus);
        hideTeaser();
        later(burstConfetti, 220);
      }
      root.dispatchEvent(new CustomEvent('cbw:subscribed', {
        bubbles: true,
        detail: { email: email, mode: cfg.optinMode, confirmed: cfg.optinMode !== 'double' }
      }));
    }

    function setLoading(on) {
      inFlight = on;
      if (on) { setState('loading'); announce(cfg.text.loading); }
      submitBtn.disabled = on;
      emailInp.disabled = on;
      submitBtn.setAttribute('aria-busy', on ? 'true' : 'false');
    }

    function handleSubmit(e) {
      if (e) e.preventDefault();
      if (inFlight) return;

      var email = (emailInp.value || '').trim();
      emailInp.setAttribute('aria-invalid', 'false');
      showMessage('', 'info');

      if (!EMAIL_RE.test(email)) {
        emailInp.setAttribute('aria-invalid', 'true');
        showMessage(cfg.text.errInvalid, 'error');
        emailInp.focus();
        return;
      }
      if (email.toLowerCase() === lastSubmittedEmail) return; /* duplicate guard */

      if (!cfg.siteId || !cfg.listId) {
        showMessage(cfg.text.errConfig, 'error');
        return;
      }

      lastSubmittedEmail = email.toLowerCase();

      /* Preview mode: simulate, never touch the real Klaviyo account. */
      if (isPreview) {
        setLoading(true);
        later(function () {
          setLoading(false);
          onAccepted(email);
        }, 900);
        return;
      }

      setLoading(true);
      subscribe(email).then(function (res) {
        setLoading(false);
        if (res.status === 202 || (res.status >= 200 && res.status < 300)) {
          onAccepted(email);
          return;
        }
        lastSubmittedEmail = '';
        if (res.status === 429) { showMessage(cfg.text.errRate, 'error'); return; }
        if (res.status === 400 || res.status === 404) { showMessage(cfg.text.errConfig, 'error'); return; }
        showMessage(cfg.text.errGeneric, 'error');
      }).catch(function () {
        setLoading(false);
        lastSubmittedEmail = '';
        showMessage(cfg.text.errNetwork, 'error'); /* entered email is preserved */
        setState('form');
      });
    }

    /* ---------------------------- copy code ---------------------------- */
    var copyResetTimer = null;
    function flashCopy(text, ok) {
      if (!copyLabel) return;
      copyLabel.textContent = text;
      copyBtn.classList.toggle('is-copied', !!ok);
      window.clearTimeout(copyResetTimer);
      copyResetTimer = window.setTimeout(function () {
        copyLabel.textContent = cfg.text.copy;
        copyBtn.classList.remove('is-copied');
      }, 2000);
    }
    function handleCopy() {
      var code = copyBtn.getAttribute('data-code') || cfg.couponCode || '';
      var done = function () { flashCopy(cfg.text.copied, true); announce(cfg.text.copied); };
      var fail = function () { flashCopy(cfg.text.copyFailed, false); };

      if (navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext) {
        navigator.clipboard.writeText(code).then(done).catch(function () { legacyCopy(code) ? done() : fail(); });
      } else {
        legacyCopy(code) ? done() : fail();
      }
    }
    function legacyCopy(text) {
      try {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.top = '-1000px';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        ta.setSelectionRange(0, text.length);
        var ok = document.execCommand('copy');
        document.body.removeChild(ta);
        return ok;
      } catch (e) { return false; }
    }

    /* ---------------------------- listeners ---------------------------- */
    function onOverlayClick(e) { if (e.target === overlay) close('backdrop'); }
    function onTeaserClick() { open('teaser'); }
    function onCloseClick() { close('close'); }
    function onDismissClick() { close('dismiss'); }
    function onSecondaryClick() { close('secondary'); }

    overlay.addEventListener('click', onOverlayClick);
    if (teaser) teaser.addEventListener('click', onTeaserClick);
    if (closeBtn) closeBtn.addEventListener('click', onCloseClick);
    if (dismissEl) dismissEl.addEventListener('click', onDismissClick);
    if (copyBtn) copyBtn.addEventListener('click', handleCopy);
    if (form) form.addEventListener('submit', handleSubmit);
    Array.prototype.forEach.call(secondary, function (b) { b.addEventListener('click', onSecondaryClick); });
    if (emailInp) emailInp.addEventListener('input', function () {
      if (msgEl && msgEl.textContent) { showMessage('', 'info'); emailInp.setAttribute('aria-invalid', 'false'); }
    });

    /* ------------------------------ boot ------------------------------ */
    setState('form');
    overlay.setAttribute('aria-hidden', 'true');
    if (!cfg.teaserFloat && teaser) teaser.classList.remove('cbw-float');

    if (isPreview) {
      setState(previewMode === 'form' ? 'form' : previewMode);
      later(function () { open('preview'); }, 120);
    } else {
      if (hasSubscribed()) {
        hideTeaser();
      } else {
        later(showTeaser, Math.max(0, parseInt(cfg.teaserDelay, 10) || 0));
        if (urlFlag('cbw_open') === '1') {
          later(function () { open('url'); }, 300);
        } else if (cfg.autoOpen && !isSuppressed()) {
          later(function () { open('auto'); }, Math.max(0, parseInt(cfg.autoOpenDelay, 10) || 0));
        }
      }
    }

    /* ----------------------------- destroy ----------------------------- */
    root.cbwDestroy = function () {
      destroyed = true;
      clearTimers();
      window.clearTimeout(copyResetTimer);
      document.removeEventListener('keydown', onKeydown, true);
      overlay.removeEventListener('click', onOverlayClick);
      if (teaser) teaser.removeEventListener('click', onTeaserClick);
      if (closeBtn) closeBtn.removeEventListener('click', onCloseClick);
      if (dismissEl) dismissEl.removeEventListener('click', onDismissClick);
      if (copyBtn) copyBtn.removeEventListener('click', handleCopy);
      if (form) form.removeEventListener('submit', handleSubmit);
      Array.prototype.forEach.call(secondary, function (b) { b.removeEventListener('click', onSecondaryClick); });
      unlockScroll();
      if (root.parentNode) root.parentNode.removeChild(root);
    };

    /* Small public API for QA / other scripts */
    root.cbwOpen = function () { open('api'); };
    root.cbwClose = function () { close('api'); };
    root.cbwReset = function () {
      storeSet(KEY_SUBBED, '');
      storeSet(KEY_DISMISS, '0');
      try { window.localStorage.removeItem(KEY_SUBBED); window.localStorage.removeItem(KEY_DISMISS); } catch (e) {}
      setState('form');
      showTeaser();
    };
  }

  /* ============================ BOOTSTRAP ============================ */
  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-cbw-root]');
    Array.prototype.forEach.call(nodes, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Theme-editor lifecycle - prevents duplicate instances and stale listeners */
  document.addEventListener('shopify:section:load', function (e) {
    var id = e.detail && e.detail.sectionId;
    var existing = id ? document.querySelector('[data-cbw-root][data-section-id="' + id + '"]') : null;
    if (existing && existing.cbwDestroy) existing.cbwDestroy();
    initAll(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var id = e.detail && e.detail.sectionId;
    var nodes = document.querySelectorAll('[data-cbw-root][data-section-id="' + id + '"]');
    Array.prototype.forEach.call(nodes, function (n) { if (n.cbwDestroy) n.cbwDestroy(); });
  });
  document.addEventListener('shopify:section:select', function (e) {
    var id = e.detail && e.detail.sectionId;
    var n = id ? document.querySelector('[data-cbw-root][data-section-id="' + id + '"]') : null;
    if (n && n.cbwOpen) n.cbwOpen();
  });
})();
